import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from 'src/lib/analyticsApi';

/**
 * Invisible component that tracks page views on every route change.
 * Place it inside <BrowserRouter> in your app root.
 */
export default function PageTracker() {
    const { pathname } = useLocation();

    useEffect(() => {
        trackPageView(pathname);
    }, [pathname]);

    return null;
}

